import React from "react";
import "./WhyChooseUs.css";
import img1 from "./img/15-Essential-Leadership-Skills-During-The-4th-Industrial-Revolution-1200x800.webp";
import img2 from "./img/d4674ed-5c4-1087-771a-1c6da456cb_77e2a255-dea8-4675-b2ee-cadb7df7efbb.jpeg";
import img3 from "./img/Unlocking-the-World-of-Competitive-Programming.jpg";
import img4 from "./img/Certified-Genrative-AI-Expert-Masterclass.webp";
import img5 from "./img/1200px-Junction_2015.webp";
import img6 from "./img/8979.jpg";

export default function WhyChooseUs() {
  const items = [
    {
      title: "Learn from Industry Leaders",
      desc: "Gain insider knowledge from senior developers and tech architects.",
      img: img1,
    },
    {
      title: "Build a Standout Portfolio",
      desc: "Work on real-world projects and showcase your skills to top employers.",
      img: img2,
    },
    {
      title: "Master Competitive Programming",
      desc: "Sharpen your coding skills with advanced algorithms and real-world challenges.",
      img: img3,
    },
    {
      title: "Exclusive Generative AI Masterclass",
      desc: "Stay ahead with hands-on training in AI-driven tools for automation & innovation.",
      img: img4,
    },
    {
      title: "Hackathons & Coding Competitions",
      desc: "Compete, win, and get noticed by industry leaders.",
      img: img5,
    },
    {
      title: "Job-Readiness Assessments",
      desc: "Crack tech roles with semester-wise coding, aptitude & technical evaluations.",
      img: img6,
    },
  ];

  return (
    <div className="timeline-wrapper">
      <h2 className="timeline-title">Why Choose Edu Tech Master Academy?</h2>
      <p className="timeline-subtitle">
        Get <b>industry-ready</b> with a cutting-edge curriculum, hands-on
        projects, and expert mentorship—designed to launch your tech career!
      </p>
      <div className="timeline">
        {items.map((item, index) => (
          <div
            className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
            key={index}
          >
            <div className="timeline-content">
              <img src={item.img} alt={item.title} />
              <div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
